import { Col, Form, Row, Space } from 'antd';
import ProductsCard from '../ProductsCard';
import RefundInformation from './RefundInformation';
import ReturnInformation from './ReturnInformation';
import ReturnChannel from './ReturnChannel';
// import WhoPayShippingFee from './WhoPayShippingFee';
import ShippingInformation from '../ShippingInformation';
import ReturnMethod from './ReturnMethod';
import CustomerInformation from '../CustomerInformation';
import { RETURN_METHOD, RETURN_SOLUTION } from 'constants/ordersReturn';
import ToWarehouse from './ToWarehouse';

export default function FormCreate() {
  return (
    <div className="mt-[20px]">
      <Row gutter={[20, 20]}>
        <Col md={15}>
          <ProductsCard />
          <div className="h-[20px]" />
          <Form.Item
            noStyle
            shouldUpdate={(prevValues, curValues) =>
              prevValues.solution !== curValues.solution
            }
          >
            {({ getFieldValue }) => {
              const solution = getFieldValue('solution');

              return (
                <Row gutter={[20, 20]}>
                  <Col
                    md={solution !== RETURN_SOLUTION['REFUND'].value ? 24 : 12}
                  >
                    <ReturnInformation />
                  </Col>
                  {solution !== RETURN_SOLUTION['REFUND'].value ? (
                    <></>
                  ) : (
                    <Col md={12}>
                      <RefundInformation />
                    </Col>
                  )}
                </Row>
              );
            }}
          </Form.Item>
        </Col>
        <Col md={9}>
          <Space direction="vertical" size={20} className="w-full">
            <ReturnChannel />
            <Form.Item
              noStyle
              shouldUpdate={(prevValues, curValues) =>
                prevValues.returnType !== curValues.returnType ||
                prevValues.returnMethod !== curValues.returnMethod
              }
            >
              {({ getFieldValue }) => {
                const returnType = getFieldValue('returnType');
                const returnMethod = getFieldValue('returnMethod');
                if (returnType === 'OFFLINE') return <></>;
                return (
                  <Space direction="vertical" size={20} className="w-full">
                    <ReturnMethod />
                    {/* <WhoPayShippingFee /> */}
                    {returnMethod === RETURN_METHOD['PICKUP'].value && (
                      <ShippingInformation hasEdit />
                    )}
                  </Space>
                );
              }}
            </Form.Item>
            <Form.Item
              noStyle
              shouldUpdate={(prevValues, curValues) =>
                prevValues.customer !== curValues.customer
              }
            >
              {({ getFieldValue }) => {
                const customer = getFieldValue('customer');
                return <CustomerInformation data={customer} />;
              }}
            </Form.Item>
            <ToWarehouse />
          </Space>
        </Col>
      </Row>
    </div>
  );
}
